import { render, staticRenderFns } from "./PresentationPackage.vue?vue&type=template&id=7df4457a&scoped=true&"
import script from "./PresentationPackage.vue?vue&type=script&lang=js&"
export * from "./PresentationPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4457a",
  null
  
)

export default component.exports